import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'tmPhoneNumberFormat',
    standalone: false
})
export class PhoneNumberFormatPipe implements PipeTransform {
    transform(value: string) {
        if (!value || value === ''){
            return value;
        }

        const space = ' ';
        const firstSpaceIndex = value.indexOf(space);
        const indexToInsertSpace = firstSpaceIndex + 3;
        if (indexToInsertSpace < value.length){
            value = `${value.substring(0, indexToInsertSpace + 1)}${space}${value.substring(indexToInsertSpace + 1)}`;
        }

        return value;
    }
}
